import { OrgPlan } from '@symon-ai/wisepipe-user';
import { ActivityType } from '../activityType';
export const activitySchema = {
    $id: 'urn:wisepipe-usages-domain:Activity',
    type: 'object',
    properties: {
        activityID: { type: 'string', uid: 9 },
        activityType: { type: 'string', enum: Object.values(ActivityType) },
        date: { type: 'string', format: 'date-time' },
        value: { type: 'number' },
        details: { type: 'array', items: { type: 'string', minLength: 1 } },
        orgID: { type: 'string', minLength: 0, maxLength: 128 },
        userID: { type: 'string', minLength: 0, maxLength: 128 },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) }
    },
    required: ['activityID', 'activityType', 'date', 'value', 'details']
};
//# sourceMappingURL=activity.js.map